/* eslint-disable no-unused-vars */
import { put, takeEvery, delay, takeLatest } from "redux-saga/effects";
import * as DocumentService from "../../secure/services/documentService";
import * as TemplateService from "../../secure/services/templateService";
import * as actions from "../actions/documentActions";
import * as documentActions from "../actions/documentActions";
import * as templateActions from "../actions/templateActions";
import * as zoneActions from "../actions/zoneActions";
import * as actionTypes from "../actions/actionTypes";
import * as actionsLoader from "../actions/loaderActions";
import * as fileUploadActions from "../actions/fileUploadActions";
import * as UtilsHelper from "../../../utils/utilsHelper";
import { StorageHelper } from "../../../utils/storageHelper";
import _ from "underscore";
import i18n from "i18next";
import { store } from "../store";
import AzureFileuploadHelper from "../../../utils/azureFileuploadHelper";

export function* getDocumentHistorySaga(data) {
  try {
    const response = yield DocumentService.doGetDocHistory(data.payload);
    const { result, isError } = response.data;

    if (!isError) {
      yield put(actions.getDocumentHistorySuccess(result));
    } else {
      yield put(actions.getDocumentHistoryFailed({}));
    }
  } catch (error) {
    yield put(actions.getDocumentHistoryFailed({}));
  }
}

export function* doGetDocumentVersionListSaga(data) {
  try {
    const response = yield DocumentService.doGetDocumentVersionList(
      data.payload
    );
    const { result, isError } = response.data;

    if (!isError) {
      yield put(actions.doGetDocumentVersionListSuccess(result));
    }
  } catch (error) {
    yield put(actions.doGetDocumentVersionListFailed({}));
  }
}

export function* getSelectedDocumentDetailSaga(data) {
  try {
    const response = yield DocumentService.getSelectedDocumentDetail(
      data.payload
    );
    const { result, isError } = response.data;

    if (!isError) {
      yield put(actions.getSelectedDocumentDetailSuccess(result));
      yield put(actions.getDocNoteSuccess(result.documentnotes));
      yield put(
        actions.getDocumentHistory({
          ...data.historyPayload,
          lastModifiedOn: result.documentDetails.lastmodifiedon,
        })
      );
    } else {
      yield put(actions.getSelectedDocumentDetailFailed({}));
    }
  } catch (error) {
    yield put(actions.getSelectedDocumentDetailFailed({}));
  }
}

export function* fetchDocumentMaster(data) {
  yield put(actionsLoader.showLoader());
  try {
    const response = yield DocumentService.doGetDocumentMaster();
    const { result, isError } = response.data;
    if (!isError) {
      const { zoneDataDto } = result;
      yield put(actions.fetchDocMasterSuccess(result));
      yield put(zoneActions.zoneDataFetchSuccess(zoneDataDto.zonedata));
    }
    if (!data.isNewDocVersionCreated) {
      yield delay(3000);
      yield put(actionsLoader.hideLoader());
    }
  } catch (error) {
    yield put(actionsLoader.hideLoader());
    yield put(actions.fetchDocMasterFailed({}));
  }
}

export function* fetchAndLoadDocumentMasterSaga(data) {
  try {
    const response = yield DocumentService.doGetDocumentMaster();
    const { result, isError } = response.data;
    if (!isError) {
      const { zoneDataDto } = result;
      yield put(actions.fetchAndLoadDocMasterSuccess(result));
      yield put(zoneActions.zoneDataFetchSuccess(zoneDataDto.zonedata));
    }
  } catch (error) {
    yield put(actions.fetchAndLoadDocMasterFailed({}));
  }
}

export function* deleteDocumentSaga(data) {
  const { payload, isDialog, isDeleteDialog, searchView } = data;
  const getStore = yield store.getState().zone;
  try {
    if (!_.isEmpty(getStore.documentDataList)) yield put(zoneActions.removeArtifact(data));
    const response = yield DocumentService.doDocumentDelete(payload);
    const { isError } = response.data;
    if (!isError) {
      if (!_.isEmpty(getStore.documentDataList)) yield put(zoneActions.removeArtifactItem(data));
      const { result } = response.data;
      const docContent = result.documentcontents
        ? JSON.parse(result.documentcontents)
        : null;
      const { documentDetails } = docContent;

      yield put(actions.deleteDocumentSuccess(documentDetails));
      const commonSearchInfo = StorageHelper.getRecentSearchInfo();
      let agGridPayload = {
        searchKey: (!_.isEmpty(commonSearchInfo) && commonSearchInfo.searchKey !== "") ? commonSearchInfo.searchKey : "",
        site: "ALL",
        countryCode: "ALL",
        pageCount: 0,
        pageSize: 20000,
        pageNumber: 1,
        artifactId: "",
        sectionid: "",
        category: "",
        milestoneGroup: "ALL",
        milestoneId: "",
        lastdocumentupdatedon: "",
      };
      yield put({ type: "AGGRID_GET_CALL", payload: agGridPayload });
      const deleteInprogress = getStore.documentDataList[
        payload.origiartifactid
      ].filter((i) => i.loader);
      if (deleteInprogress[0].length <= 0) {
        yield put(
          zoneActions.getDocumentsBySection(payload.sectionOrigid, true)
        );
      }
      yield put(actions.fetchDocMaster());
      yield put(zoneActions.fetchMetricsData());
    } else {
      if (isDeleteDialog) yield put(actionsLoader.hideLoader());
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actionsLoader.showError(errorMessage, "error", "warning"));
      yield put(actions.deleteDocumentFailed());
    }
  } catch (error) {
    yield put(actions.deleteDocumentFailed());
  }
}

export function* deleteAGGridSaga(data) {
  const { payload, isDialog, isDeleteDialog, searchView } = data;
  let response;
  try {
    if (payload.category) {
      response = yield TemplateService.deleteDropZoneDocument(payload.id);
    } else {
      response = yield DocumentService.doDocumentDelete(payload);
    }
    const { isError } = response.data;
    if (!isError) {
      const commonSearchInfo = StorageHelper.getRecentSearchInfo();
      let payload = {
        searchKey: (!_.isEmpty(commonSearchInfo) && commonSearchInfo.searchKey !== "") ? commonSearchInfo.searchKey : "",
        site: "ALL",
        countryCode: "ALL",
        pageCount: 0,
        pageSize: 20000,
        pageNumber: 1,
        artifactId: "",
        sectionid: "",
        category: "",
        milestoneGroup: "ALL",
        milestoneId: "",
        lastdocumentupdatedon: "",
      };
      let documentContentDetails;
      if (!data.payload.category) {
        documentContentDetails = response.data.result.documentcontents
          ? JSON.parse(response.data.result.documentcontents)
          : null;
        yield put(actions.deleteAGGridDocumentSuccess(documentContentDetails.documentDetails));
      }
      yield put(actions.deleteAGGridDocumentSuccess(response.data.result));
      yield put({ type: "AGGRID_GET_CALL", payload: payload });
    } else {
      yield put(actions.deleteAGGridDocumentFailed());
    }
  } catch (error) {
    yield put(actions.deleteAGGridDocumentFailed());
  }
}

export function* aggridGetDocumentSaga(data) {
  const { payload } = data;
  try {
    yield put({ type: "AGGRID_GET_DOCUMENT" });
    const response = yield DocumentService.aggridGetDocument(payload);
    const { isError } = response.data;
    if (!isError) {
      const { result } = response.data;
      yield put(zoneActions.fetchMetricsData());
      yield put({ type: "AGGRID_GET_DOCUMENT_SUCCESS", payload: result });
    } else {
      yield put({ type: "AGGRID_GET_DOCUMENT_FAILURE" });
      yield put(
        actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning")
      );
    }
  } catch (error) {
    yield put({ type: "AGGRID_GET_DOCUMENT_FAILURE" });
    yield put(
      actionsLoader.showError(i18n.t("TMF.TOAST_SOMETHINGWENTWRONG"), "error", "warning")
    );
  }
}

export function* documentStatusChange(data) {
  try {
    let response = null;
    yield put(actions.documentStatusInProgress());
    if (data.payload.workflowAction === "publish") {
      response = yield DocumentService.docPublishDocDetails(data.payload);
    } else if (data.payload.workflowAction === "Approve") {
      response = yield DocumentService.docApproveDoc(data.payload);
      data.payload.docDetailsList.status = "Finalized";
    } else if (data.payload.workflowAction === "unpublish") {
      response = yield DocumentService.docUnPublishDocDetails(data.payload);
    } else if (data.payload.workflowAction === "saveChanges") {
      response = yield DocumentService.docUpdateChanges(data.payload);
    }
    if (!response.data.isError) {
      StorageHelper.clearFilteredData();
      yield put(actions.documentStatusChangeSuccess(response.data.result));
      const { ismodified } = response.data.result;
      if (!ismodified) {
        yield put(actions.documentStatusChangeSuccess(response.data.result));

        let lastdocumentupdatedon = sessionStorage.getItem(
          "lastdocumentupdatedon"
        );
        let req = {
          searchKey: "",
          site: "ALL",
          countryCode: "ALL",
          pageCount: 0,
          pageSize: 20000,
          pageNumber: 1,
          artifactId: "",
          sectionid: "",
          category: "",
          milestoneGroup: "ALL",
          milestoneId: "",
          lastdocumentupdatedon: lastdocumentupdatedon || "",
        };
        if (!_.isEmpty(data.category)) {
          yield put(templateActions.fetchDropZoneDocuments(data.category));
          yield put(templateActions.getDropZoneSettings(data.category));
          yield put(
            zoneActions.getDocumentsByArtifact(
              data.payload.origiartifactid,
              data.payload.docDetailsList?.fileguid ||
              data.payload.docDetailsList?.dropzonefileguid
            )
          );
        }

        if (
          data.payload?.docDetailsList !== undefined &&
          !data.payload.category
        ) {
          yield put(
            zoneActions.getDocumentsBySection(
              data.payload?.docDetailsList.sectionid
            )
          );
          yield put(
            zoneActions.getDocumentsByArtifact(
              data.payload?.docDetailsList.origiartifactid
            )
          );
        }

        if (data.payload?.setdocDetailsList) {
          let result = response.data.result;
          if (data.payload.workflowAction === "saveChanges" || data.payload.workflowAction === "Approve") {
            result = JSON.parse(response.data.result.documentcontents).documentDetails;
          }
          data.payload?.setdocDetailsList({
            ...data.payload?.docDetailsList,
            ...result,
          }); //object update
        }
        yield put(actions.fetchDocMaster());
        yield put(zoneActions.fetchMetricsData());
        if (data.payload?.docDetailsList !== undefined) {
          if (
            data.payload?.docDetailsList.origiartifactid !==
            response.data.result.origiartifactid &&
            !data.payload.category
          ) {
            yield put(
              zoneActions.getDocumentsByArtifact(
                response.data.result.origiartifactid
              )
            );
            yield put(
              zoneActions.getDocumentsBySection(
                response.data.result.origiartifactid
                  .split(".")
                  .slice(0, 2)
                  .join(".")
              )
            );
          }
        }
        const payloadData = {
          documentid: data.payload.documentId,
          lastModifiedOn: response.data.result.modifiedat,
          documentversionguid: data.payload.documentversionguid,
        };
        if (!data.payload.docDetailsList.tmfdropzoneid && !data?.payload?.hasOwnProperty("xfdfstring")) {
          yield put(documentActions.isDocumentstatusChangeHistory(true)); // Added this action to keep track of document status change saga history call in order to avoid unwanted history call on document view modal
          yield put(documentActions.getDocumentHistory(payloadData));
        }
        yield put(actionsLoader.hideError());

        let recentSearchInfo = StorageHelper.getRecentSearchInfo();
        if (!_.isEmpty(recentSearchInfo)) {
          StorageHelper.setRecentSearchInfo(recentSearchInfo);
          yield put({ type: "AGGRID_GET_CALL", payload: recentSearchInfo });
        } else {
          StorageHelper.setRecentSearchInfo(req);
          yield put({ type: "AGGRID_GET_CALL", payload: req });
        }
      } else {
        yield put(actions.documentStatusInProgressFailed(i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD")));
      }
      if (data.payload.workflowAction === "Approve") {
        yield put(actions.getDocSharingUserList({ documentid: data.payload.documentId, isrequiredclinic: true, isrequiredsubject: data.payload.docDetailsList.trialmasterfilesharingsettings.isenabledforsubjectusers }));
      }
    } else {
      if (data.payload.workflowAction === "Approve" || data.payload.workflowAction === "saveChanges") {
        data.payload.docDetailsList.status = "Awaiting review";
      }
      if (data.payload.workflowAction === "publish") {
        data.payload.docDetailsList.status = "Unpublished";
      }
      yield put(actions.documentStatusChangeFailed());
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.documentStatusInProgressFailed(errorMessage));
    }
    if (data.payload?.setIsActionLoading) {
      data.payload?.setIsActionLoading(false); //loader
    }
  } catch (e) {
    if (data.payload.workflowAction === "Approve" || data.payload.workflowAction === "saveChanges") {
      data.payload.docDetailsList.status = "Awaiting review";
    }
    if (data.payload.workflowAction === "publish") {
      data.payload.docDetailsList.status = "Unpublished";
    }
    yield put(actions.documentStatusChangeFailed());
    yield put(actions.documentStatusInProgressFailed(e.message));
  }
}

export function* fetchDocumentLockSaga(data) {
  yield put(actionsLoader.showLoader());
  try {
    const response = yield DocumentService.doDocumentLock(data.payload);
    const { result, isError } = response.data;
    if (!isError) {
      yield put(zoneActions.getDocumentsBySection(data.payload.sectionId));
      yield put(actions.fetchDocumentLockSuccess(result));
      const payloadData = {
        documentid: data.payload.documentId,
        lastModifiedOn: result.lastmodifiedon,
        documentversionguid: data.payload.documentversionguid,
      };

      const { origiartifactid } = result;
      if (!_.isEmpty(origiartifactid)) yield put(actions.fetchDocMaster());
      yield put(zoneActions.getDocumentsByArtifact(origiartifactid));

      if (data.payload?.setdocDetailsList) {
        data.payload?.setdocDetailsList({
          ...data.payload?.docDetailsList,
          ...result,
        }); //object update
      }
      yield put(zoneActions.fetchMetricsData());
      yield put(documentActions.getDocumentHistory(payloadData));
    } else {
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(actions.fetchDocumentLockFailed(errorMessage));
    }
    if (data.payload?.setIsActionLoading) {
      data.payload?.setIsActionLoading(false); //loader
    }
  } catch (error) {
    yield put(actions.fetchDocumentLockFailed({}));
  }
}

export function* documentGetReviewSaga(data) {
  try {
    const response = yield DocumentService.doGetReviewActionDetail(
      data.payload
    );
    const { result, isError } = response.data;
    if (!isError) {
      yield put(documentActions.documentGetReviewSuccess(result));
    } else {
      yield put(documentActions.documentGetReviewFailed());
    }
  } catch (error) {
    yield put(documentActions.documentGetReviewFailed());
  }
}

export function* documentSaveReviewSaga(data) {
  try {
    yield put(actions.documentStatusInProgress());
    const response = yield DocumentService.doSaverevieweraction(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(documentActions.documentSaveReviewSuccess(result));
      yield put(documentActions.documentStatusChangeSuccess(result));
      const payloadData = {
        documentid: data.payload.documentId,
        lastModifiedOn: result.modifiedat,
        documentversionguid: data.payload.documentversionguid,
      };
      if (data.payload?.setdocDetailsList) {
        let result = JSON.parse(response.data.result.documentcontents).documentDetails;
        data.payload?.setdocDetailsList({
          ...data.payload?.docDetailsList,
          ...result,
        }); //object update
      }
      yield put(documentActions.getDocumentHistory(payloadData));
      let lastdocumentupdatedon = sessionStorage.getItem(
        "lastdocumentupdatedon"
      );

      let req = {
        searchKey: "",
        site: "ALL",
        countryCode: "ALL",
        pageCount: 0,
        pageSize: 20000,
        pageNumber: 1,
        artifactId: "",
        sectionid: "",
        category: "",
        milestoneGroup: "ALL",
        milestoneId: "",
        lastdocumentupdatedon: lastdocumentupdatedon || "",
      };
      let recentSearchInfo = StorageHelper.getRecentSearchInfo();
      if (!_.isEmpty(recentSearchInfo)) {
        StorageHelper.setRecentSearchInfo(recentSearchInfo);
        yield put({ type: "AGGRID_GET_CALL", payload: recentSearchInfo });
      } else {
        StorageHelper.setRecentSearchInfo(req);
        yield put({ type: "AGGRID_GET_CALL", payload: req });
      }

      if (!_.isEmpty(result.origiartifactid)) {
        yield put(zoneActions.getDocumentsByArtifact(result.origiartifactid));
      }
      if (!_.isEmpty(result.sectionid)) {
        yield put(zoneActions.getDocumentsBySection(result.sectionid));
      }
      yield put(zoneActions.fetchMetricsData());
    } else {
      data.payload.docDetailsList.status = "Awaiting review";
      const errorMessage = UtilsHelper.constructErrorMsg(response.data);
      yield put(documentActions.documentStatusChangeFailed());
      yield put(documentActions.documentSaveReviewFailed(errorMessage));
    }
  } catch (error) {
    data.payload.docDetailsList.status = "Awaiting review";
    yield put(documentActions.documentStatusChangeFailed());
    yield put(documentActions.documentSaveReviewFailed());
  }
}

export function* addDocNoteSaga(data) {
  try {
    const response = yield DocumentService.addDocNote(data.payload);
    const { result, isError } = response.data;
    if (!isError) {
      yield put(actions.addDocNoteSuccess(result));
    }
  } catch (error) {
    yield put(actions.addDocNoteFailed());
  }
}
export function* getDocNoteSaga(data) {
  try {
    let versionId = data.payload;
    let dropzoneId = data.dropzoneId;
    const response = yield DocumentService.getDocNote(versionId, dropzoneId);
    const { result, isError } = response.data;
    if (!isError) {
      yield put(actions.getDocNoteSuccess(result));
    }
  } catch (error) {
    yield put(actions.getDocNoteFailed());
  }
}
export function* resolveDocNoteSaga(data) {
  try {
    const response = yield DocumentService.resolveDocNote(data.payload);
    const { result, isError } = response.data;
    if (!isError) {
      yield put(actions.resolveDocNoteSuccess(result));
      yield put(actions.getDocNoteSuccess(result));
    }
  } catch (error) {
    yield put(actions.resolveDocNoteFailed());
  }
}

export function* getMileStoneArtifactCountSaga(data) {
  try {
    const response = yield DocumentService.getMileStoneArtifactCount(
      data.payload
    );
    const { isError, result } = response.data;
    if (!isError) {
      yield put(
        actions.getMileStoneArtifactCountSuccess(result.milestoneArtifacts)
      );
    } else {
      yield put(actions.getMileStoneArtifactCountFailed());
    }
  } catch (error) {
    yield put(actions.getMileStoneArtifactCountFailed());
  }
}

export function* getDocumentContentDetailsSaga(action) {
  const { documentVersionId, documentId } = action;
  try {
    const response = yield DocumentService.getDocumentContentDetails(
      documentId,
      documentVersionId
    );
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDocumentContentDetailsSuccess(result));
    }
  } catch (error) {
    yield put(actions.getDocumentContentDetailsFailed());
  }
}

export function* getCustomizedColState(data) {
  try {
    let reqData = data.payload;
    const response = yield DocumentService.getCustomizedColState(reqData);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getCustomizedColumStateSuccess(result));
    } else {
      yield put(actions.getCustomizedColumStateFailed());
    }
  } catch (error) {
    yield put(actions.getCustomizedColumStateFailed());
  }
}
export function* saveCustomizedColState(data) {
  try {
    let reqData = {
      UserPreference: data.payload.UserPreference,
      FilterPreference: data.payload.FilterPreference,
    };
    const response = yield DocumentService.saveCustomizedColState(reqData);
    const { isError, result } = response.data;
    if (!isError) {
      sessionStorage.setItem("customizedColState", data.payload.UserPreference);
      sessionStorage.setItem(
        "customizedFilterState",
        data.payload.FilterPreference
      );
      yield delay(2000);
      yield put(actions.saveCustomizedColumStateSuccess(result));
    } else {
      yield put(
        actionsLoader.showError(
          i18n.t("TMF.TOAST_DOCUPDATEFAILEDREFRESHRELOAD"), "error", "warning"
        )
      );
      yield put(actions.saveCustomizedColumStateFailed());
    }
  } catch (error) {
    yield put(actions.saveCustomizedColumStateFailed());
  }
}

export function* getAdminsharingsSettingSaga() {
  try {
    const response = yield DocumentService.getAdminsharingSettings();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getAdminSharingSettingsSuccess(result));
    } else {
      yield put(actions.getAdminSharingSettingsFailed());
    }
  } catch (error) {
    yield put(actions.getAdminSharingSettingsFailed());
  }
}

export function* getDocSharingMetricsByVersionIdSaga(action) {
  try {
    const response = yield DocumentService.getDocumentSharingMetricsByVersion(action.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDocSharingMetricsByVersionIdSuccess(result));
      yield put(actionsLoader.hideLoader());
    }
  } catch (error) {
    yield put(actions.getDocSharingMetricsByVersionIdFailed());
  }
}

export function* getExistingSharedUserListSaga(action) {
  try {
    const { documentid, isForceDataGet, lastModifiedOn } = action.payload;
    yield put(actions.isBindersCallRunning(true));
    const response = yield DocumentService.getExistingSharedUserList(documentid, isForceDataGet, lastModifiedOn);
    const { isError, result } = response.data;
    if (!isError) {
      if (result.uselocalstore) {
        let binderVal = {
          binderList: action.existingUsersData,
          lastbindercreatedon: result.lastbindercreatedon
        };
        yield put(actions.getExistingSharedUsersListSuccess(binderVal));
      } else {
        yield put(actions.getExistingSharedUsersListSuccess(result));
        if (action.from === 'binderProperty' && !result.uselocalstore) {
          yield put(actions.getDocumentContentDetails(
            documentid,
            action.versionId
          ));
          yield put(actions.getDocSharingMetricsByVersionId(
            documentid,
          ));
        }
      }

      yield put(actions.isBindersCallRunning(false));
    }
  } catch (error) {
    yield put(actions.getExistingSharedUsersListFailed());
    yield put(actions.isBindersCallRunning(false));
  }
}

export function* getDocSharingUserSaga(action) {
  try {
    const response = yield DocumentService.getDocumentSharingUsers(action.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDocSharingUserListSuccess(result));
    }
  } catch (error) {
    yield put(actions.getDocSharingUserListFailed());
  }
}

export function* getSharedFileCount(data) {
  try {
    const response = yield DocumentService.doGetSharedFileCount(data.payload);
    const { result, isError } = response.data;

    if (!isError) {
      yield put(actions.getSharedFileCountSuccess(result, data.isDocInfoUpdated));
    }
  } catch (error) {
    yield put(actions.getSharedFileCountFailed({}));
  }
}

export function* updateUserSharedListSaga(action) {
  try {
    const response = yield DocumentService.updateUserSharedListService(action.payload);
    const { isError } = response.data;
    if (!isError) {
      yield put(actions.getSharedFileCount(action.payload.fileguid, false));
    }
  } catch (error) {
    yield put(actions.updateUserSharedListFailed({}));
  }
}

export function* getBindersDetailsSaga(action) {
  try {
    const response = yield DocumentService.getBindersDetails(action.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getBindersDetailSuccess(result));
      yield put(actions.getDocumentContentDetailsSuccess(result.documentContentDetails));
    }
  } catch (error) {
    yield put(actions.getBindersDetailFailed());
  }
}

export function* createNewBinderForSharingSaga(action) {
  try {
    yield put(actionsLoader.showLoader());
    const response = yield DocumentService.createBinderForSharing(action.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getDocSharingMetricsByVersionId(action.payload.documentid));
      const reqPayload = {
        documentid: action.payload.documentid,
        isForceDataGet: true,
        lastModifiedOn: null
      }
      yield put(actions.getExistingSharedUsersList(reqPayload));
      yield put(actions.createBinderDetailsForSharingSuccess());
    } else {
      yield put(actions.createBinderDetailsForSharingFailed(response.data.responseException.exceptionMessage))
      yield put(actionsLoader.hideLoader());
    }
  } catch (error) {
    yield put(actionsLoader.hideLoader());
    yield put(actions.getBindersDetailFailed());
  }
}

export function* downloadSignatureDetailsSaga(data) {
  try {
    const response = yield DocumentService.downloadSignatureDetailsWithSAS(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      let fileurl = atob(result.sastoken);
      let downloadInfo = {
        downloadFileName: data.payload.friendlyfilename,
        type: "pdf"
      }
      let downFileResponse = yield AzureFileuploadHelper.downloadAzureFile(
        fileurl,
        downloadInfo
      );
      yield put(actions.downloadSignatureDetailsSuccess());
      yield put(actions.downloadSignatureDetailsFailed());

    } else {
      yield put(actions.downloadSignatureDetailsFailed());
    }
  } catch (error) {
    yield put(actions.downloadSignatureDetailsFailed());
  }
}
export function* getBindersHistorySaga(data) {
  try {
    const response = yield DocumentService.getBindersHistory(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.getBindersHistorySuccess(result));
    } else {
      yield put(actions.getBindersHistoryFailed());
    }
  } catch (error) {
    yield put(actions.getBindersHistoryFailed());
  }
}

export function* recallBinderSaga(data) {
  try {
    yield put(actionsLoader.showLoader());
    const response = yield DocumentService.reCallBinders(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.reCallBinderSuccess(result));
      yield put(actions.getBindersHistory(data.payload.sharingbinderid));
      yield put(actionsLoader.hideLoader());
    } else {
      yield put(actionsLoader.hideLoader());
      yield put(actions.reCallBinderFailed(response.data.responseException.exceptionMessage));
    }
  } catch (error) {
    yield put(actionsLoader.hideLoader());
    yield put(actions.reCallBinderFailed(error));
  }
}
export function* downloadSharingDetailsSaga(action) {
  try {
    yield put(fileUploadActions.showDownloadLoader(true));
    let response = yield DocumentService.downloadSharingDetails(action.payload);
    if (!response.data.isError) {
      if (response.data.result.iszipfilecreationtriggerted) {
        let reqPayload = {
          sharingActionId: response.data.result.sharingactionid,
          zipFileName: action.validFilename
        }
        yield put(actions.getDownloadSharingStatus(reqPayload, action.validFilename));
      } else {
        yield put(fileUploadActions.showDownloadLoader(false));
      }
    } else {
      yield put(fileUploadActions.showDownloadLoader(false));
    }
  } catch (error) {

  }
}
export function* downloadSignatureZipDetailsSaga(action) {
  try {
    yield put(fileUploadActions.showDownloadLoader(true));
    let response = yield DocumentService.downloadSignatureZipDetails(action.payload);
    if (!response.data.isError) {
      if (response.data.result.iszipfilecreationtriggerted) {
        let reqPayload = {
          sharingActionId: response.data.result.sharingactionid,
          zipFileName: action.validFilename
        }
        yield put(actions.getDownloadSharingStatus(reqPayload, action.validFilename));
      } else {
        yield put(fileUploadActions.showDownloadLoader(false));
      }
    } else {
      yield put(fileUploadActions.showDownloadLoader(false));
    }
  } catch (error) {
    yield put(fileUploadActions.showDownloadLoader(false));
  }
}
export function* getDownloadSharingDetailsStatusSaga(action) {
  try {
    yield put(fileUploadActions.showDownloadLoader(true));
    let response = yield DocumentService.getDownloadSharingDetailsStatus(action.payload);
    if (!response.data.isError) {
      switch (response.data.result.fileStatus) {
        case "CreatingZipFile":
          yield put(actions.getDownloadSharingStatus(action.payload, action.validFilename));
          break;
        case "ZipFileUploaded":
          var link = document.createElement('a');
          link.href = response.data.result.fileSASToken;
          link.click();
          yield put(fileUploadActions.showDownloadLoader(false));
          break;
        default:
          yield put(fileUploadActions.showDownloadLoader(false));
          break;
      }
    }
  } catch (error) {
    yield put(fileUploadActions.showDownloadLoader(false));
  }
}

export function* downloadWithNotesSaga(data) {
  try {
    yield put(fileUploadActions.showDownloadLoader(true));
    const response = yield DocumentService.downloadWithNotes(data.payload);
    const { isError, result } = response.data;
    if (!isError) {
      let fileurl = atob(result.sastoken);
      let downloadInfo = {
        downloadFileName: data.payload.friendlyfilename,
        type: "pdf"
      }
      yield AzureFileuploadHelper.downloadAzureFile(
        fileurl,
        downloadInfo
      );
      yield put(fileUploadActions.showDownloadLoader(false));
    } else {
      yield put(fileUploadActions.showDownloadLoader(false));
    }

  } catch (error) {
    yield put(fileUploadActions.showDownloadLoader(false));
  }
};

export function* watchDocumentAsync() {
  yield takeLatest(actionTypes.FETCH_DOCUMENT_MASTER, fetchDocumentMaster);
  yield takeLatest(actionTypes.FETCH_LOAD_DOCUMENT_MASTER, fetchAndLoadDocumentMasterSaga);
  yield takeEvery(actionTypes.FETCH_DOCUMENT_DELETE, deleteDocumentSaga);
  yield takeEvery(actionTypes.FETCH_DOCUMENT_LOCK, fetchDocumentLockSaga);
  yield takeEvery(actionTypes.DOCUMENT_STATUS_CHANGE, documentStatusChange);
  yield takeEvery(
    actionTypes.DOCUMENT_STATUS_SAVE_REVIEW,
    documentSaveReviewSaga
  );
  yield takeEvery(
    actionTypes.DOCUMENT_STATUS_GET_REVIEW,
    documentGetReviewSaga
  );

  yield takeEvery(
    actionTypes.GET_SELECTED_DOCUMENT_HISTORY,
    getDocumentHistorySaga
  );

  yield takeEvery(actionTypes.REMOVE_AG_GRID_LIST, deleteAGGridSaga);

  yield takeEvery(
    actionTypes.GET_DOCUMENT_VERSION_LIST,
    doGetDocumentVersionListSaga
  );
  yield takeEvery(
    actionTypes.GET_SELECTED_DOCUMENT_DETAIL,
    getSelectedDocumentDetailSaga
  );
  yield takeLatest("AGGRID_GET_CALL", aggridGetDocumentSaga);
  yield takeEvery(actionTypes.ADD_DOC_NOTE, addDocNoteSaga);
  yield takeEvery(actionTypes.GET_DOC_NOTE, getDocNoteSaga);
  yield takeEvery(actionTypes.RESOLVE_DOC_NOTE, resolveDocNoteSaga);
  yield takeEvery(
    actionTypes.GET_MILESTONE_ARTIFACT_COUNT,
    getMileStoneArtifactCountSaga
  );
  yield takeEvery(
    actionTypes.GET_DOCUMENT_CONTENT_DETAILS,
    getDocumentContentDetailsSaga
  );

  yield takeEvery(actionTypes.GET_CUSTOMIZED_COLSTATE, getCustomizedColState);
  yield takeEvery(actionTypes.SAVE_CUSTOMIZED_COLSTATE, saveCustomizedColState);
  yield takeEvery(actionTypes.GET_ADMIN_SHARING_SETTING, getAdminsharingsSettingSaga);
  yield takeEvery(actionTypes.GET_SHARING_METRICS_BY_VERSION, getDocSharingMetricsByVersionIdSaga);
  yield takeEvery(actionTypes.GET_EXISTING_SHARED_USER_LIST, getExistingSharedUserListSaga);
  yield takeEvery(actionTypes.GET_DOC_SHARE_USER_LIST, getDocSharingUserSaga);
  yield takeEvery(actionTypes.GET_SHARED_FILE_COUNT, getSharedFileCount);
  yield takeEvery(actionTypes.UPDATE_USER_SHARED_LIST, updateUserSharedListSaga);
  yield takeEvery(actionTypes.GET_BINDERS_DETAIL, getBindersDetailsSaga);
  yield takeEvery(actionTypes.CREATE_NEW_BINDER_FOR_SHARING, createNewBinderForSharingSaga);
  yield takeEvery(actionTypes.GET_BINDERS_HISTORY, getBindersHistorySaga);
  yield takeEvery(actionTypes.DOWNLOAD_SIGNATURE_DETAILS, downloadSignatureDetailsSaga);
  yield takeEvery(actionTypes.RECALL_BINDER, recallBinderSaga);
  yield takeEvery(actionTypes.DOWNLOAD_SHARING_DETAILS, downloadSharingDetailsSaga);
  yield takeEvery(actionTypes.GET_DOWNLOAD_SHARING_STATUS, getDownloadSharingDetailsStatusSaga);
  yield takeEvery(actionTypes.DOWNLOAD_SIGNATURE_ZIP_DETAILS, downloadSignatureZipDetailsSaga);
  yield takeEvery(actionTypes.DOWNLOAD_WITH_NOTES, downloadWithNotesSaga);
}
